import { render } from "./PointNavigationBar.vue?vue&type=template&id=10f12ad4&scoped=true"
import script from "./PointNavigationBar.vue?vue&type=script&lang=js"
export * from "./PointNavigationBar.vue?vue&type=script&lang=js"

import "./PointNavigationBar.vue?vue&type=style&index=0&id=10f12ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f12ad4"],['__file',"src/vue/components/PointNavigationBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10f12ad4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10f12ad4', __exports__)) {
    api.reload('10f12ad4', __exports__)
  }
  
  module.hot.accept("./PointNavigationBar.vue?vue&type=template&id=10f12ad4&scoped=true", () => {
    api.rerender('10f12ad4', render)
  })

}


export default __exports__